"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function BeginYourTransformation() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="224590" id="begin-your-transformation" className="dark bg-background text-foreground relative overflow-hidden py-32 md:py-48 flex items-center min-h-[60vh]">
      {}
      <div className="absolute inset-0 overflow-hidden pointer-events-none z-0">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full max-w-[1200px] opacity-60">
          <div className="absolute top-[-10%] left-[-10%] w-[60%] h-[60%] rounded-lg bg-primary/40 blur-3xl mix-blend-screen" />
          <div className="absolute bottom-[-10%] right-[-10%] w-[50%] h-[50%] rounded-lg bg-secondary/40 blur-3xl mix-blend-screen" />
          <div className="absolute top-[20%] left-[30%] w-[40%] h-[40%] rounded-lg bg-blue-500/30 blur-3xl mix-blend-screen" />
        </div>
      </div>

      {}
      <div className="absolute right-0 top-1/2 -translate-y-1/2 w-[40%] max-w-[500px] hidden lg:block pointer-events-none z-10">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1688832/img/consulting_abstract_innovation_sphere.png" alt="Future Mind Consulting Innovation Sphere" className="w-full h-auto object-contain opacity-90 drop-shadow-2xl" style={{
        animation: "float 6s ease-in-out infinite"
      }} />
      </div>

      {}
      <div className="container mx-auto px-4 md:px-6 relative z-20">
        <div ref={ref} className={`max-w-4xl mx-auto lg:mx-0 lg:max-w-2xl text-center lg:text-left transition-all duration-1000 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <h2 className="font-default text-5xl md:text-7xl lg:text-8xl font-bold tracking-tighter text-white mb-10 leading-[1.1]">
            Ready to Lead the Next Era?
          </h2>
          
          <Button asChild size="lg" className="h-16 px-10 text-xl rounded-md bg-primary text-primary-foreground hover:bg-primary/90 shadow-2xl shadow-primary/20 transition-transform hover:scale-105">
            <Link to="/ConnectPage">
              Begin Your Transformation
            </Link>
          </Button>
        </div>
      </div>

      {}
      <style dangerouslySetInnerHTML={{
      __html: `
          @keyframes float {
            0% { transform: translateY(0px) rotate(0deg); }
            50% { transform: translateY(-20px) rotate(2deg); }
            100% { transform: translateY(0px) rotate(0deg); }
          }
        `
    }} />
    </section>;
}